import { useQuery } from "@tanstack/react-query";
import productsApi from "../api/products";

export default function useAutoCompleteQuery(searchString: string) {
  return useQuery(['autocomplete', searchString], () => productsApi.getAutoComplete(searchString), { enabled: !!searchString, keepPreviousData: true })
}